import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CenterIntro from './components/CenterIntro';
import Programs from './components/Programs';
import CounselingDetails from './components/CounselingDetails';
import Counselors from './components/Counselors';
import Booking from './components/Booking';
import Location from './components/Location';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Navbar />
      <Hero />
      <CenterIntro />
      <Programs />
      <CounselingDetails />
      <Counselors />
      <Booking />
      <Location />
      <Footer />
    </div>
  );
}